import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

const EditableCell = ({ value, placeholder = '—', onClick }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
      width: '100%',
      cursor: 'pointer',
      overflow: 'hidden',
      '&:hover .edit-icon': { opacity: 1 },
    }}
    onClick={onClick}
  >
    <Box sx={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {value || placeholder}
    </Box>
    <EditIcon
      className="edit-icon"
      fontSize="small"
      sx={{ opacity: 0, transition: 'opacity 0.2s', color: 'text.secondary', flexShrink: 0 }}
    />
  </Box>
);

EditableCell.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default EditableCell;
